// extracted by mini-css-extract-plugin
module.exports = {"block":"_17004","list":"_11484","item":"_5173","actions":"_9847","icon":"_19630"};